module.exports = __webpack_public_path__ + "static/media/water-work.793a606e.mp4";